<div
  #editViewElement
  style="font-size: 16px"
  [attr.data-cy-editview-tablename]="editTabs[0]?.data.tableName"
  [attr.data-cy-editview-tablevel]="editTabs[0]?.data.tabLevel"
  [ngClass]="cssClass"
  [style.height.%]="100">
  @if (isZoomTarget) {
    <div
      class="iupics-blade-content-sidebar"
      [ngClass]="[GridViewVisibility === 'hidden' ? 'invisible' : 'visible']"
      [ngStyle]="{ visibility: GridViewVisibility }">
      <div class="iupics-blade-content-sidebar-content visible">
        <div class="p-toolbar ui-widget-header ui-corner-all ui-helper-clearfix">
          <div class="ui-right" (click)="GridViewVisibility = 'hidden'">
            <button class="p-button p-menu-bar-button p-button-icon-only" icon="icon-close" pButton type="button">
              {{ '' }}
            </button>
          </div>
        </div>
        <iu-grid-view-ui
          #gridViewUi
          [DOMParentComponent]="container"
          [container]="container"
          [cssClass]="'iupics-blade-content-first'"
          [data]="zoomTargetData[0].data"
          [gridTabFilter]="filterZoomTarget"
          [hasUniversalFilter]="true"
          [isMenuDisplay]="true"
          [isZoomTargetGrid]="true"
          [tabId]="zoomTargetData[0].tabId"
          [windowType]="undefined"
          (gridTabAfterViewInitEmitter)="onZoomTargetGridAfterViewInit($event)"
          (gridViewCellClicked)="gridViewCellClicked($event)" />
      </div>
    </div>
  }

  <iu-menu-bar-detail-ui
    [activeTabID]="container?.activeTab?.id"
    [arrowsDisplayed]="
      linkedComponents && linkedComponents.length > 0 ? linkedComponents[0].children.length === 0 : false
    "
    [breadcrumb]="container.breadcrumbComponent"
    [changingMenuBar]="changingMenuBar"
    [datastorekey]="currentDataStoreKey"
    [isDeleteable]="isDeleteable"
    [isInsertRecord]="isInsertRecord"
    [isReadOnly]="isReadOnly"
    [isSplitView]="isSplitView"
    [isZoomEditView]="isZoomEditView"
    [isZoomTarget]="zoomTarget ? true : false"
    [linkedComponents]="linkedComponents"
    [nbRequest]="nbRequest"
    [nbUploadedFiles]="nbUploadedFiles"
    [noData]="noData"
    [processed]="
      editTabs[0] && editTabs[0].dataStored && editTabs[0].dataStored.data ? editTabs[0].dataStored.data.Processed : 'N'
    "
    [status]="editTabs[0] && editTabs[0].dataStored ? editTabs[0].dataStored.status : DatastoreStatus.SYNC"
    [tabId]="tabId"
    [viewRecordChangeLogLabel]="editTabs[0] ? editTabs[0]?.data.label : ('tabUi.loading' | translate)"
    (changeGridElementEvent)="changeGridElement($event)"
    (changeGridViewVisibility)="changeGridViewVisibility()"
    (closeEvent)="checkBeforeClose($event)"
    (copyEvent)="copyData($event)"
    (deleteEvent)="deleteData($event)"
    (emailEvent)="updateModalDisplay({ display: { key: 'displayEmailEditor', value: true } })"
    (exportDataEvent)="updateModalDisplay({ display: { key: 'displayExportDataModal', value: true } })"
    (joinFilesEvent)="updateModalDisplay({ display: { key: 'displayJoinFilesPanel', value: true } })"
    (newEvent)="openNew($event)"
    (noteEvent)="showNotes()"
    (printEvent)="printReport($event)"
    (refreshEvent)="refreshData(true, $event)"
    (requestEvent)="showRequest()"
    (saveEvent)="beforeSave($event)"
    (viewRecordChangeLog)="viewRecordChangeLog()" />
  @if (isLoading) {
    <p-progressBar [mode]="'indeterminate'" [showValue]="false" [styleClass]="'loading-progressbar'" [value]="0" />
  }

  <div class="compContainer">
    <div class="contentInline" style="font-size: 16px; word-break: break-all" [style.width]="cssWidth">
      <div class="iu-editview-info">
        <div class="tabManage">
          <ul class="tabNamesManager">
            <li>
              <a class="open-icon-title" href="#" (click)="$event.preventDefault()">
                <span>{{ 'editView.sections' | translate }}</span>
                <i aria-hidden="true" class="icon-next-ancre"></i>
              </a>
              <ul class="tab-list">
                @for (tab of editTabs; track i; let i = $index) {
                  @if (tab.displayCss !== 'none') {
                    <li>
                      <a class="open-icon" href="#" (click)="$event.preventDefault(); goToAnchor($event, tab)">
                        <span>{{ tab.label }}</span>
                        <i aria-hidden="true" class="icon-next-ancre"></i>
                      </a>
                    </li>
                  }
                }
              </ul>
            </li>
            @if (processes().length) {
              <li>
                <a class="open-icon-title" href="#" (click)="$event.preventDefault()">
                  <span>{{ 'editView.processes' | translate }}</span>
                  <i aria-hidden="true" class="icon-next-ancre"></i>
                </a>
                <ul class="tab-list">
                  @for (process of processes(); track $index) {
                    @if (tabId && tabId === process.tabId) {
                      <li>
                        <a
                          class="open-icon"
                          href="#"
                          [ngClass]="{ readonly: process.readOnly }"
                          (click)="process.readOnly ? null : $event.preventDefault(); showProcess(process)">
                          <span>{{ process.label }}</span>
                          <i aria-hidden="true" class="fas fa-cog"></i>
                        </a>
                      </li>
                    }
                  }
                </ul>
              </li>
            }
          </ul>
        </div>
        <iu-menu-smart-buttons-ui [tabId]="tabId" [windowId]="data?.AD_Window_ID" />
      </div>
      @if (isStepperVisible) {
        @if (editTabs[0] && editTabs[0].data && editTabs[0].data.isDocumentTab) {
          <div #stepperDiv class="p-col-12 ui-stepper">
            <iu-stepper-ui
              [changingStepper]="changingStepper"
              [data]="editTabs[0].data.stepperData"
              [editTab]="editTabs[0]"
              [isIndexNumber]="false"
              [isReadOnly]="isLoading"
              [parent]="this"
              [preventPrevious]="true"
              (refreshEdit)="refreshEditViews(false)" />
          </div>
        } @else if (isStepperEmpty) {
          <div class="p-col-12 ui-stepper">
            <iu-stepper-ui [isReadOnly]="true" />
          </div>
        }
      }

      @if (conflictsResult.refreshAuto) {
        <iu-banner type="success">
          {{ 'editView.refreshAutoMsg' | translate }}
        </iu-banner>
      } @else if (conflictsResult.mustRefresh) {
        <iu-banner icon="icon-refresh3x" type="warning">
          {{ 'editView.mustRefreshMsg' | translate }}
        </iu-banner>
      }
      @if (conflictsResult.hasConflicts) {
        <iu-banner type="error">
          {{ 'editView.hasConflictsMsg' | translate }}
          <a style="text-decoration: underline; cursor: pointer" (click)="wantToMergeConflicts = true">
            {{ 'editView.verify' | translate }}
          </a>
          {{ 'editView.andSave' | translate }} <br />{{ nbConflicts }} {{ 'editView.remainingConflict' | translate }}
        </iu-banner>
      }
      <p-scrollPanel
        [style]="{
          width: '100%',
          height: isStepperVisible ? 'calc(100% - ' + stepperElt?.nativeElement?.offsetHeight + 'px)' : '100%',
        }">
        <div #gridUi class="p-col contentInlineScrollPanel blade-grid" id="{{ scrollPanelid }}">
          <ng-template iuDynamicContainer />
        </div>
      </p-scrollPanel>
    </div>
    <div class="contentInline2">
      @if (additionalInfoWidthExpanded) {
        <article #article class="accordion" style="position: relative" [style.height.%]="100">
          <section
            id="acc1"
            [ngClass]="[!isAdditionalOpened ? 'additionalHidden' : '']"
            [style.height.%]="100"
            [style.width]="additionalInfoWidth">
            <h2>
              <a #openButton (click)="isAdditionalOpened ? minimize() : resize()">
                <i aria-hidden="true" class="icon-up"></i>
                <span>{{ 'editView.additionalInformation' | translate }}</span>
              </a>
            </h2>
            <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
              <ng-container #additionalInfoVcr />
            </p-scrollPanel>
          </section>
        </article>
      }
    </div>
    <div #sideBladeContainer class="side-blade-wraper" [attr.data-expanded]="sideComponentRef !== null">
      @if (sideComponentRef) {
        <div class="side-blade-header-content">
          <div class="side-blade-title">
            <i aria-hidden="true" [class]="sideBladeIconClass"></i>
            <span class="title" pTooltip="{{ sideBladeTitle }}">{{ sideBladeTitle }}</span>
          </div>
          <div class="side-blade-buttons">
            <iu-prime-speedDial
              buttonClassName="p-button-outlined"
              direction="down"
              hideIcon="fa fa-times"
              showIcon="icon-menu-bullets"
              [model]="sideBladeButtons"
              [radius]="50" />
          </div>
        </div>
      }
      <div class="side-blade-content" [ngClass]="[sideComponentRef ? 'side-blade-content-shown' : '']">
        <ng-container #sideBladeVcr />
      </div>
      @if (sideComponentRef) {
        <div
          class="resizable-handle"
          (mousedown)="startResizeSideBlade($event)"
          (touchstart)="startResizeSideBlade($event)">
          <i aria-hidden="true" class="fa fa-caret-right"></i>
        </div>
      }
    </div>
  </div>
</div>

@if (wantToMergeConflicts) {
  <div class="modal-background">
    <iu-mergetool [conflictsResult]="conflictsResult" [parentEditView]="this" (mergeEmitter)="onMerge($event)" />
  </div>
}

<p-sidebar
  #sideBar
  position="right"
  styleClass="p-sidebar-md "
  [baseZIndex]="0"
  [dismissible]="false"
  [(visible)]="isSidebarOpen"
  (onHide)="closeSideBarAndBlade()">
  <ng-container #sideBarVcr />
</p-sidebar>
<!-- #region audit panel -->
@if (showAuditsPanel) {
  <iu-modal-ui [title]="'editView.registeredInformation' | translate" (closeModalEmitter)="showAuditsPanel = false">
    <ng-template #vcrAudit />
  </iu-modal-ui>
}
<!-- #endregion -->

@if (displayJoinFilesPanel) {
  <iu-modal-ui
    [contentType]="ModalContentType.JOINFILES"
    [hasCloseBtn]="true"
    [title]="'joinFiles.title'"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayJoinFilesPanel', value: false } })">
    <iu-join-file-ui
      [adTab_ID]="tabId"
      [adTable_ID]="table_id"
      [data]="data"
      [dsKey]="currentDataStoreKey"
      [(nbUploadedFiles)]="nbUploadedFiles"
      (openFileOnSideEmitter)="showPreview($event)" />
  </iu-modal-ui>
}
@if (displayEmailEditor) {
  <iu-modal-ui
    [title]="'email.title'"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayEmailEditor', value: false } })">
    <iu-email-editor-ui
      [parentEditView]="this"
      (cancelEmailEmitter)="updateModalDisplay({ display: { key: 'displayEmailEditor', value: false } })" />
  </iu-modal-ui>
}
@if (displayExportDataModal) {
  <iu-modal-ui
    #exportDataModal
    [angularStyle]="{ 'iu-modal-body': { overflow: 'unset' } }"
    [title]="'exportData.title'"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayExportDataModal', value: false } })">
    <iu-export-data-ui
      [dsKey]="currentDataStoreKey"
      [sourceModal]="exportDataModal"
      [tabId]="tabId"
      [tableId]="editTabs[0].data.AD_Table_ID"
      (afterExecute)="updateNbFileAttached()"
      (cancelExportDataEmitter)="updateModalDisplay({ display: { key: 'displayExportDataModal', value: false } })" />
  </iu-modal-ui>
}
@if (displayProcessUI) {
  <iu-modal-ui
    [angularStyle]="{ 'iu-modal-body': { padding: 0 } }"
    [contentType]="ModalContentType.PROCESS"
    [hasCloseBtn]="true"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayProcessUI', value: false } })">
    <iu-process-ui
      [isModal]="true"
      [parentComponent]="this"
      [sourceComponentData]="displayProcessUI_sourceComponentData"
      [windowId]="processId"
      (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayProcessUI', value: false } })" />
  </iu-modal-ui>
}
<div [ngClass]="[!displayFormUI ? 'hidden' : '', 'specificModal']">
  <iu-modal-ui
    #specificModal
    [angularStyle]="customFormModalBodyCss"
    [contentType]="ModalContentType.FORM"
    [isModalDisplay]="displayFormUI"
    [modalClass]="modalClass"
    [title]="specificWindowTitle"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayFormUI', value: false } })">
    <ng-template #vcrSpecific />
  </iu-modal-ui>
</div>
